webpackJsonp([246649594372185],{

/***/ 212:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.MemphisImageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(12);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _HeroSmall = __webpack_require__(8);
	
	var _HeroSmall2 = _interopRequireDefault(_HeroSmall);
	
	var _LocationMicroNav = __webpack_require__(10);
	
	var _LocationMicroNav2 = _interopRequireDefault(_LocationMicroNav);
	
	var _LocationContent = __webpack_require__(9);
	
	var _LocationContent2 = _interopRequireDefault(_LocationContent);
	
	var _LocationRelated = __webpack_require__(11);
	
	var _LocationRelated2 = _interopRequireDefault(_LocationRelated);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MemphisLocation = function (_React$Component) {
	  _inherits(MemphisLocation, _React$Component);
	
	  function MemphisLocation() {
	    _classCallCheck(this, MemphisLocation);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  MemphisLocation.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_HeroSmall2.default, { location: 'Memphis, TN' }),
	      _react2.default.createElement(_LocationMicroNav2.default, null),
	      _react2.default.createElement(_LocationContent2.default, {
	        category: 'PlacesForBikes',
	        title: 'Big Jump in Bluff City',
	        story: 'The Big Jump\'s focus area in South Memphis is a low-income neighborhood with a majority African-American population. It exhibits all of the typical signs of generational poverty and lack of investment in infrastructure. Core services are lacking: grocery stores, doctors, community centers, etc. A highly motivated community is working to change the neighborhood\u2019s trajectory. Biking has increased during the last seven years, partly a result of infrastructure and the creation of destinations that people need and want to travel to.'
	      }),
	      _react2.default.createElement(_gatsbyImage2.default, {
	        title: 'MemphisTN',
	        alt: 'Memphis breaking the cycle of poverty',
	        sizes: this.props.data.memphisOneTwoImage.sizes
	      }),
	      _react2.default.createElement(_LocationRelated2.default, {
	        prevLocationName: 'Texas',
	        prevLocationPath: 'texas',
	        prevLocationImgPath: this.props.data.memphisPrevImage,
	        nextLocationName: 'Iowa',
	        nextLocationPath: 'iowa',
	        nextLocationImgPath: this.props.data.memphisNextImage
	      })
	    );
	  };
	
	  return MemphisLocation;
	}(_react2.default.Component);
	
	exports.default = MemphisLocation;
	
	// GraphQL query
	
	var MemphisImageQuery = exports.MemphisImageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-memphis-js-38498093f76c06a0f7cb.js